export const FIELD_BILLING_ADDRESS_VALUE = 'billing_address';
export const FIELD_SHIPPING_ADDRESS_VALUE = 'shipping_address';